import styled from 'styled-components';
import { Tabs, Tab } from '@blueprintjs/core';
import * as ROUTES from '../../../constants/routes';

const StyledTabs = styled(Tabs)`
  overflow-x: auto;
  width: 100%;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari/Opera */
  }

  .bp3-tab {
    color: #666;
    font-size: 1rem;
    font-family: var(--fonts-heading);

    &[aria-selected="true"] {
      font-weight: bold;
    }
  }
`;

const ChatTabs = ({ chatThreads = [], history }) => {
  const handleTabClick = (tabId) => {
    const path = `${ROUTES.AI_CHAT}/${tabId}`;
    if (!history) window.location.pathname = path;
    else history.push(path);
  };

  const getSelectedTabId = () => {
    if (!history) return null;
    const { location = {} } = history;
    const { pathname = '' } = location;
    const parts = pathname.split('/').filter(Boolean);
    // pathname is /ai-chat/:threadId - return the threadId
    return parts.length > 1 ? parts[parts.length - 1] : null;
  };

  const selectedTabId = getSelectedTabId();

  if (!chatThreads || chatThreads.length === 0) {
    return null;
  }

  return (
    <StyledTabs
      id="ChatThreadTabs"
      selectedTabId={selectedTabId}
      onChange={handleTabClick}
    >
      {chatThreads.map(({ title, id }) => {
        const displayTitle = title && title.length > 25 
          ? `${title.substring(0, 25)}...` 
          : title;
        return <Tab id={id} key={id} title={displayTitle} />;
      })}
    </StyledTabs>
  );
};

export default ChatTabs;
